import { createMofaConfig } from "./create-mofa-config";

export const defaultAppConfig = {
  appsUMD: '/assets/maintenance/maintenance-umd.js',
  appsCommonsJS: '/assets/maintenance/maintenance-commonjs.js',
  appContent: null,
  createFunctionInstance: createMofaConfig,
};
